import { render, staticRenderFns } from "./Updates.vue?vue&type=template&id=2ad9ea82&scoped=true&"
import script from "./Updates.js?vue&type=script&lang=js&"
export * from "./Updates.js?vue&type=script&lang=js&"
import style0 from "./Updates.scss?vue&type=style&index=0&id=2ad9ea82&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ad9ea82",
  null
  
)

export default component.exports